module.exports = __webpack_public_path__ + "e99802cd1115d0a38fa0b29f2ed53f3a.svg";